import {
  NOTIFICATION_COUNT,
  NOTIFICATION_ERROR,
  NOTIFICATION_LIST,
  NOTIFICATION_LOADING,
  NOTIFICATION_READ,
  NOTIFICATION_READ_ROLLBACK,
} from "../actions/type";
const initialState = {
  items: [],
  unreadCount: 0,
  pagination: {},
  loading: false,
  error: "",
};
export default function notification(state = initialState, action) {
  switch (action.type) {
    case NOTIFICATION_LIST:
      return { ...state, ...action.payload };
    case NOTIFICATION_COUNT:
      return { ...state, unreadCount: action.payload };
    case NOTIFICATION_READ: {
      const selected = state.items.find(
        (item) => String(item.id) === String(action.payload),
      );
      if (!selected || selected.read) return state;
      return {
        ...state,
        unreadCount: Math.max(Number(state.unreadCount) - 1, 0),
        items: state.items.map((item) =>
          String(item.id) === String(action.payload)
            ? { ...item, read: true }
            : item,
        ),
      };
    }
    case NOTIFICATION_READ_ROLLBACK: {
      const selected = state.items.find(
        (item) => String(item.id) === String(action.payload),
      );
      if (!selected || !selected.read) return state;
      return {
        ...state,
        unreadCount: Number(state.unreadCount) + 1,
        items: state.items.map((item) =>
          String(item.id) === String(action.payload)
            ? { ...item, read: false }
            : item,
        ),
      };
    }
    case NOTIFICATION_LOADING:
      return { ...state, loading: action.payload };
    case NOTIFICATION_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
